import styled, { css } from 'styled-components';

export const ActionsWrapper = styled.div`
  width: 100%;
  display: ${props => (props.search || props.edit ? 'grid' : 'none')};
  grid-template-columns: ${props => (props.search && props.edit ? 'auto auto' : 'auto')};
  position: ${({ search }) => !search && 'relative'};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: ${props => (props.search || props.edit ? 'flex' : 'none')};
    justify-content: ${({ search }) => (search ? 'flex-start' : 'flex-end')};
    width: ${({ editMode }) => (editMode ? '96%' : '90%')};
  }

  @media print {
    display: none;
  }
`;
